import { RefreshCw } from 'lucide-react'
import { MdClose } from 'react-icons/md'

import { Badge } from '@/modules/shared/components/ui/badge'

type FilterBadgeProps = {
  label: string
  value: string
  onRemove: () => void
  canRemove?: boolean
  refresh?: boolean
}

export function OrderFilterBadge({
  label,
  value,
  refresh,
  onRemove,
  canRemove = true,
}: FilterBadgeProps) {
  return (
    <Badge className="cursor-pointer h-8 rounded-sm bg-foreground/5 text-foreground hover:bg-foreground/10 items-center">
      {refresh && <RefreshCw size={16} className="mr-2" color="gray" />}
      {`${label}: `} <p className="ml-2 text-[11px] font-normal">{value}</p>
      {canRemove && <MdClose size={16} onClick={onRemove} color="gray" />}
    </Badge>
  )
}
